import { useQueryClient } from '@tanstack/react-query'
import { useCallback, useContext } from 'react'

import { useModals } from '@app/context/ModalsContext'

import { useAccountWriteContext } from '@context/AccountContextContext'
import { AuthSessionContext } from '@context/AuthContext'
import { useEntitySettings } from '@context/EntityContext'
import { useSignup } from '@context/SignupContext'

import { SharedContext, initialSharedContext } from '@utils/SharedContext'
import { getTickmillCompanyByHostname } from '@utils/companyName.utils'

import { clearLocalStorage } from './useStorage'

export const useLogout = (): { logout(): void } => {
  const queryClient = useQueryClient()
  const [, setSharedState] = useContext(SharedContext)
  const { clearAccount } = useAccountWriteContext()
  const [, setAuth] = useContext(AuthSessionContext)
  const [, setEntity] = useEntitySettings()
  const { resetLead, resetValues } = useSignup()
  const { closeAllModals } = useModals()

  const logout = useCallback(async () => {
    closeAllModals()
    queryClient.clear()
    setSharedState(initialSharedContext)
    clearAccount()
    clearLocalStorage()
    resetLead()
    resetValues()
    setAuth(null)
    setEntity({ entity: getTickmillCompanyByHostname() })
  }, [
    clearAccount,
    resetValues,
    resetLead,
    setAuth,
    setEntity,
    setSharedState,
    queryClient,
    closeAllModals,
  ])

  return { logout }
}
